import apiFetch from '../apiFetch'

export default function (idPool) {  
  return apiFetch({
    endPoint: `Pool/generarPDFPantalla?idPool=${idPool}`,
    method: 'GET', body: null, token: null
  })
}
